









import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import type { BankId } from '../../../types/bankid';

export default defineComponent({
  props: {
    error: {
      type: String,
      required: true,
    },
    bankId: {
      type: Object as PropType<BankId>,
      required: true,
    },
  },
});
